import React, { useState, useRef, useEffect } from 'react';
import '../CSS/JobUpload.css';

const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
  'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho',
  'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
  'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
  'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
  'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma',
  'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
  'West Virginia', 'Wisconsin', 'Wyoming'
];

const STATE_CITIES: { [key: string]: string[] } = {
  'Alabama': ['Birmingham', 'Montgomery', 'Mobile', 'Huntsville', 'Tuscaloosa'],
  'Alaska': ['Anchorage', 'Fairbanks', 'Juneau', 'Sitka', 'Ketchikan'],
  'Arizona': ['Phoenix', 'Tucson', 'Mesa', 'Chandler', 'Scottsdale', 'Glendale', 'Tempe'],
  'Arkansas': ['Little Rock', 'Fayetteville', 'Fort Smith', 'Jonesboro', 'North Little Rock'],
  'California': ['Los Angeles', 'San Diego', 'San Jose', 'San Francisco', 'Fresno', 'Sacramento', 'Long Beach', 'Oakland', 'Bakersfield', 'Anaheim'],
  'Colorado': ['Denver', 'Colorado Springs', 'Aurora', 'Fort Collins', 'Lakewood'],
  'Connecticut': ['Bridgeport', 'New Haven', 'Hartford', 'Stamford', 'Waterbury'],
  'Delaware': ['Wilmington', 'Dover', 'Newark', 'Middletown', 'Smyrna'],
  'Florida': ['Jacksonville', 'Miami', 'Tampa', 'Orlando', 'St. Petersburg', 'Hialeah', 'Tallahassee', 'Fort Lauderdale'],
  'Georgia': ['Atlanta', 'Augusta', 'Columbus', 'Savannah', 'Athens'],
  'Hawaii': ['Honolulu', 'Hilo', 'Kailua', 'Kaneohe', 'Kahului'],
  'Idaho': ['Boise', 'Nampa', 'Meridian', 'Idaho Falls', 'Pocatello'],
  'Illinois': ['Chicago', 'Aurora', 'Naperville', 'Joliet', 'Rockford', 'Elgin', 'Peoria'],
  'Indiana': ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Carmel'],
  'Iowa': ['Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City', 'Iowa City'],
  'Kansas': ['Wichita', 'Overland Park', 'Kansas City', 'Olathe', 'Topeka'],
  'Kentucky': ['Louisville', 'Lexington', 'Bowling Green', 'Owensboro', 'Covington'],
  'Louisiana': ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Lake Charles'],
  'Maine': ['Portland', 'Lewiston', 'Bangor', 'South Portland', 'Auburn'],
  'Maryland': ['Baltimore', 'Frederick', 'Rockville', 'Gaithersburg', 'Bowie'],
  'Massachusetts': ['Boston', 'Worcester', 'Springfield', 'Cambridge', 'Lowell'],
  'Michigan': ['Detroit', 'Grand Rapids', 'Warren', 'Sterling Heights', 'Lansing', 'Ann Arbor'],
  'Minnesota': ['Minneapolis', 'St. Paul', 'Rochester', 'Duluth', 'Bloomington'],
  'Mississippi': ['Jackson', 'Gulfport', 'Southaven', 'Hattiesburg', 'Biloxi'],
  'Missouri': ['Kansas City', 'St. Louis', 'Springfield', 'Columbia', 'Independence'],
  'Montana': ['Billings', 'Missoula', 'Great Falls', 'Bozeman', 'Butte'],
  'Nebraska': ['Omaha', 'Lincoln', 'Bellevue', 'Grand Island', 'Kearney'],
  'Nevada': ['Las Vegas', 'Henderson', 'Reno', 'North Las Vegas', 'Sparks'],
  'New Hampshire': ['Manchester', 'Nashua', 'Concord', 'Derry', 'Rochester'],
  'New Jersey': ['Newark', 'Jersey City', 'Paterson', 'Elizabeth', 'Edison'],
  'New Mexico': ['Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe', 'Roswell'],
  'New York': ['New York', 'Buffalo', 'Rochester', 'Yonkers', 'Syracuse', 'Albany', 'New Rochelle'],
  'North Carolina': ['Charlotte', 'Raleigh', 'Greensboro', 'Durham', 'Winston-Salem'],
  'North Dakota': ['Fargo', 'Bismarck', 'Grand Forks', 'Minot', 'West Fargo'],
  'Ohio': ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton'],
  'Oklahoma': ['Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Lawton'],
  'Oregon': ['Portland', 'Eugene', 'Salem', 'Gresham', 'Hillsboro'],
  'Pennsylvania': ['Philadelphia', 'Pittsburgh', 'Allentown', 'Erie', 'Reading', 'Scranton'],
  'Rhode Island': ['Providence', 'Warwick', 'Cranston', 'Pawtucket', 'East Providence'],
  'South Carolina': ['Charleston', 'Columbia', 'North Charleston', 'Mount Pleasant', 'Rock Hill'],
  'South Dakota': ['Sioux Falls', 'Rapid City', 'Aberdeen', 'Pierre', 'Brookings'],
  'Tennessee': ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Clarksville'],
  'Texas': ['Houston', 'San Antonio', 'Dallas', 'Austin', 'Fort Worth', 'El Paso', 'Arlington', 'Corpus Christi'],
  'Utah': ['Salt Lake City', 'West Valley City', 'Provo', 'West Jordan', 'Orem'],
  'Vermont': ['Burlington', 'Essex', 'South Burlington', 'Colchester', 'Rutland'],
  'Virginia': ['Virginia Beach', 'Norfolk', 'Richmond', 'Newport News', 'Alexandria'],
  'Washington': ['Seattle', 'Spokane', 'Tacoma', 'Vancouver', 'Bellevue'],
  'West Virginia': ['Charleston', 'Huntington', 'Parkersburg', 'Morgantown', 'Wheeling'],
  'Wisconsin': ['Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Racine'],
  'Wyoming': ['Cheyenne', 'Casper', 'Laramie', 'Gillette', 'Rock Springs']
};

const STATUS_OPTIONS = [
  'Active',
  'Inactive',
  'Pending',
  'Closed'
];

const JobUpload: React.FC = () => {
  const [formData, setFormData] = useState({
    schoolIcon: null as File | null,
    schoolName: '',
    jobTitle: '',
    state: '',
    city: '',
    applicationLink: '',
    profileUpload: null as File | null,
    nominateLink: '',
    currentStatus: '',
    description: ''
  });

  const [charCount, setCharCount] = useState(0);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showTextColorPicker, setShowTextColorPicker] = useState(false);
  const [showHighlightColorPicker, setShowHighlightColorPicker] = useState(false);
  const editorRef = useRef<HTMLDivElement>(null);
  const fontFamilyRef = useRef<HTMLSelectElement>(null);
  const fontSizeRef = useRef<HTMLSelectElement>(null);
  const textColorPickerRef = useRef<HTMLDivElement>(null);
  const highlightColorPickerRef = useRef<HTMLDivElement>(null);

  const MAX_CHARACTERS = 5000;

  // Formatting functions for WYSIWYG editor
  const formatText = (command: string, value?: string) => {
    document.execCommand(command, false, value);
    updateContent();
  };

  const updateContent = () => {
    if (editorRef.current) {
      const htmlContent = editorRef.current.innerHTML;
      const textContent = editorRef.current.textContent || '';
      setCharCount(textContent.length);
      setFormData(prev => ({ ...prev, description: htmlContent }));
    }
  };

  const handleInput = () => {
    updateContent();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    
    // If state changes, clear the city selection
    if (name === 'state') {
      setFormData(prev => ({
        ...prev,
        state: value,
        city: '' // Clear city when state changes
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: 'schoolIcon' | 'profileUpload') => {
    const file = e.target.files?.[0] || null;
    if (fieldName === 'profileUpload' && file && !file.name.toLowerCase().endsWith('.pdf')) {
      alert('Only PDF files are allowed for School Profile');
      e.target.value = '';
      return;
    }
    setFormData(prev => ({
      ...prev,
      [fieldName]: file
    }));
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const text = e.clipboardData.getData('text/plain');
    document.execCommand('insertText', false, text);
    updateContent();
  };

  const handleFontFamilyChange = () => {
    if (fontFamilyRef.current) {
      formatText('fontName', fontFamilyRef.current.value);
    }
  };

  const handleFontSizeChange = () => {
    if (fontSizeRef.current) {
      formatText('fontSize', fontSizeRef.current.value);
    }
  };

  const handleTextColorClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowTextColorPicker(!showTextColorPicker);
    setShowHighlightColorPicker(false);
  };

  const handleHighlightColorClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowHighlightColorPicker(!showHighlightColorPicker);
    setShowTextColorPicker(false);
  };

  const handleTextColorSelect = (color: string) => {
    formatText('foreColor', color);
    setShowTextColorPicker(false);
  };

  const handleHighlightColorSelect = (color: string) => {
    formatText('backColor', color);
    setShowHighlightColorPicker(false);
  };

  // Standard color palette (similar to Google Docs)
  const colorPalette = [
    '#000000', '#434343', '#666666', '#999999', '#B7B7B7', '#CCCCCC', '#D9D9D9', '#EFEFEF', '#F3F3F3', '#FFFFFF',
    '#980000', '#FF0000', '#FF9900', '#FFFF00', '#00FF00', '#00FFFF', '#4A86E8', '#0000FF', '#9900FF', '#FF00FF',
    '#E6B8AF', '#F4CCCC', '#FCE5CD', '#FFF2CC', '#D9EAD3', '#D0E0E3', '#C9DAF8', '#CFE2F3', '#D9D2E9', '#EAD1DC',
    '#DD7E6B', '#EA9999', '#F9CB9C', '#FFE599', '#B6D7A8', '#A2C4C9', '#A4C2F4', '#9FC5E8', '#B4A7D6', '#D5A6BD',
    '#CC4125', '#E06666', '#F6B26B', '#FFD966', '#93C47D', '#76A5AF', '#6D9EEB', '#6FA8DC', '#8E7CC3', '#C27BA0',
    '#A61C00', '#CC0000', '#E69138', '#F1C232', '#6AA84F', '#45818E', '#3C78D8', '#3D85C6', '#674EA7', '#A64D79',
    '#85200C', '#990000', '#B45F06', '#BF9000', '#38761D', '#134F5C', '#1155CC', '#0B5394', '#351C75', '#741B47',
    '#5B0F00', '#660000', '#783F04', '#7F6000', '#274E13', '#0C343D', '#1C4587', '#073763', '#20124D', '#4C1130'
  ];

  // Close color pickers when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      const clickedInsideTextColor = textColorPickerRef.current?.contains(target);
      const clickedInsideHighlightColor = highlightColorPickerRef.current?.contains(target);
      
      if (!clickedInsideTextColor && !clickedInsideHighlightColor) {
        setShowTextColorPicker(false);
        setShowHighlightColorPicker(false);
      }
    };

    if (showTextColorPicker || showHighlightColorPicker) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTextColorPicker, showHighlightColorPicker]);

  const validateForm = (): boolean => {
    if (!formData.schoolName.trim()) {
      alert('School Name is required');
      return false;
    }
    if (!formData.jobTitle.trim()) {
      alert('Job Title is required');
      return false;
    }
    if (!formData.state) {
      alert('State is required');
      return false;
    }
    if (!formData.city) {
      alert('City is required');
      return false;
    }
    if (formData.applicationLink && !isValidUrl(formData.applicationLink)) {
      alert('Please enter a valid Application Link URL');
      return false;
    }
    if (formData.nominateLink && !isValidUrl(formData.nominateLink)) {
      alert('Please enter a valid Nominate Link URL');
      return false;
    }
    if (!formData.currentStatus) {
      alert('Current Status is required');
      return false;
    }
    if (charCount > MAX_CHARACTERS) {
      alert(`Description exceeds the maximum character limit of ${MAX_CHARACTERS}`);
      return false;
    }
    return true;
  };

  const isValidUrl = (url: string): boolean => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      setShowConfirmation(false);
      return;
    }

    setIsSubmitting(true);
    try {
      // Create FormData for file uploads
      const submitData = new FormData();
      if (formData.schoolIcon) {
        submitData.append('schoolIcon', formData.schoolIcon);
      }
      submitData.append('schoolName', formData.schoolName);
      submitData.append('jobTitle', formData.jobTitle);
      submitData.append('city', formData.city);
      submitData.append('state', formData.state);
      submitData.append('location', `${formData.city}, ${formData.state}`); // Keep for backward compatibility
      submitData.append('applicationLink', formData.applicationLink);
      if (formData.profileUpload) {
        submitData.append('profileUpload', formData.profileUpload);
      }
      submitData.append('nominateLink', formData.nominateLink);
      submitData.append('description', formData.description);

      // Get token from localStorage or sessionStorage
      const token = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
      
      const response = await fetch('http://127.0.0.1:3060/api/admin/create-job', {
        method: 'POST',
        headers: token ? {
          'Authorization': `Bearer ${token}`
        } : {},
        body: submitData
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || data.message || 'Failed to create job');
      }

      alert('Job uploaded successfully!');
      
      // Reset form
      setFormData({
        schoolIcon: null,
        schoolName: '',
        jobTitle: '',
        state: '',
        city: '',
        applicationLink: '',
        profileUpload: null,
        nominateLink: '',
        currentStatus: '',
        description: ''
      });
      if (editorRef.current) {
        editorRef.current.innerHTML = '';
      }
      setCharCount(0);
      setShowConfirmation(false);
    } catch (error: any) {
      console.error('Error submitting form:', error);
      alert(error.message || 'Error submitting form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      setShowConfirmation(true);
    }
  };

  return (
    <div className="job-upload-page">
      <div className="job-upload-container">
        <h1 className="job-upload-title">Please provide the following information</h1>
        
        <form className="job-upload-form" onSubmit={handleFormSubmit}>
          <div className="job-upload-form-columns">
            {/* Left Column */}
            <div className="job-upload-column job-upload-column-left">
              <div className="job-upload-field">
                <label htmlFor="schoolName" className="job-upload-label">
                  School Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="schoolName"
                  name="schoolName"
                  value={formData.schoolName}
                  onChange={handleInputChange}
                  className="job-upload-input"
                  placeholder="Enter School Name"
                  required
                />
              </div>

              <div className="job-upload-field">
                <label htmlFor="jobTitle" className="job-upload-label">
                  Job Title <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="jobTitle"
                  name="jobTitle"
                  value={formData.jobTitle}
                  onChange={handleInputChange}
                  className="job-upload-input"
                  placeholder="Enter Job Title"
                  required
                />
              </div>

              <div className="job-upload-field-row">
                <div className="job-upload-field job-upload-field-half">
                  <label htmlFor="state" className="job-upload-label">
                    State <span className="required">*</span>
                  </label>
                  <select
                    id="state"
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    className="job-upload-select"
                    required
                  >
                    <option value="">Select</option>
                    {US_STATES.map(state => (
                      <option key={state} value={state}>{state}</option>
                    ))}
                  </select>
                </div>

                <div className="job-upload-field job-upload-field-half">
                  <label htmlFor="city" className="job-upload-label">
                    City <span className="required">*</span>
                  </label>
                  <select
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    className="job-upload-select"
                    required
                    disabled={!formData.state}
                  >
                    <option value="">{formData.state ? 'Select' : 'Select State First'}</option>
                    {formData.state && STATE_CITIES[formData.state]?.map(city => (
                      <option key={city} value={city}>{city}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="job-upload-field">
                <label htmlFor="applicationLink" className="job-upload-label">
                  Link to apply <span className="required">*</span>
                </label>
                <input
                  type="url"
                  id="applicationLink"
                  name="applicationLink"
                  value={formData.applicationLink}
                  onChange={handleInputChange}
                  className="job-upload-input"
                  placeholder="https://example.com/apply"
                  required
                />
              </div>

              <div className="job-upload-field">
                <label htmlFor="profileUpload" className="job-upload-label">
                  School Profile <span className="required">*</span> <span className="file-format-note">(support pdf format only)</span>
                </label>
                <input
                  type="file"
                  id="profileUpload"
                  accept=".pdf"
                  onChange={(e) => handleFileChange(e, 'profileUpload')}
                  className="job-upload-file-input"
                  required
                />
                {formData.profileUpload && (
                  <div className="file-preview">
                    <span className="file-name">{formData.profileUpload.name}</span>
                  </div>
                )}
              </div>

              <div className="job-upload-field">
                <label htmlFor="nominateLink" className="job-upload-label">
                  Nomination Link <span className="required">*</span>
                </label>
                <input
                  type="url"
                  id="nominateLink"
                  name="nominateLink"
                  value={formData.nominateLink}
                  onChange={handleInputChange}
                  className="job-upload-input"
                  placeholder="https://example.com/nominate"
                  required
                />
              </div>

              <div className="job-upload-field">
                <label htmlFor="currentStatus" className="job-upload-label">
                  Current Status <span className="required">*</span>
                </label>
                <select
                  id="currentStatus"
                  name="currentStatus"
                  value={formData.currentStatus}
                  onChange={handleInputChange}
                  className="job-upload-select"
                  required
                >
                  <option value="">Select</option>
                  {STATUS_OPTIONS.map(status => (
                    <option key={status} value={status}>{status}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Right Column */}
            <div className="job-upload-column job-upload-column-right">
              <div className="job-upload-field">
                <label htmlFor="schoolIcon" className="job-upload-label">
                  School Logo Image <span className="required">*</span>
                </label>
                <input
                  type="file"
                  id="schoolIcon"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, 'schoolIcon')}
                  className="job-upload-file-input"
                  required
                />
                {formData.schoolIcon && (
                  <div className="file-preview">
                    <img 
                      src={URL.createObjectURL(formData.schoolIcon)} 
                      alt="School icon preview" 
                      className="file-preview-image"
                    />
                    <span className="file-name">{formData.schoolIcon.name}</span>
                  </div>
                )}
              </div>

              <div className="job-upload-field">
                <label htmlFor="description" className="job-upload-label">
                  Description <span className="char-count">({charCount} / {MAX_CHARACTERS} characters)</span>
                </label>
                <div className="wysiwyg-toolbar">
                  <button type="button" onClick={() => formatText('bold')} className="toolbar-btn" title="Bold">
                    <strong>B</strong>
                  </button>
                  <button type="button" onClick={() => formatText('italic')} className="toolbar-btn" title="Italic">
                    <em>I</em>
                  </button>
                  <button type="button" onClick={() => formatText('underline')} className="toolbar-btn" title="Underline">
                    <u>U</u>
                  </button>
                  <div className="toolbar-color-picker-wrapper" ref={textColorPickerRef}>
                    <button type="button" onClick={handleTextColorClick} className="toolbar-btn toolbar-btn-color" title="Text Color">
                      <span className="color-icon">A</span>
                    </button>
                    {showTextColorPicker && (
                      <div className="color-picker-popup">
                        <div className="color-palette-grid">
                          {colorPalette.map((color, index) => (
                            <button
                              key={index}
                              type="button"
                              className="color-palette-item"
                              style={{ backgroundColor: color }}
                              onClick={() => handleTextColorSelect(color)}
                              title={color}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="toolbar-color-picker-wrapper" ref={highlightColorPickerRef}>
                    <button type="button" onClick={handleHighlightColorClick} className="toolbar-btn toolbar-btn-highlight" title="Highlight Color">
                      <span className="highlight-icon">✎</span>
                    </button>
                    {showHighlightColorPicker && (
                      <div className="color-picker-popup">
                        <div className="color-palette-grid">
                          {colorPalette.map((color, index) => (
                            <button
                              key={index}
                              type="button"
                              className="color-palette-item"
                              style={{ backgroundColor: color }}
                              onClick={() => handleHighlightColorSelect(color)}
                              title={color}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <button type="button" onClick={() => formatText('justifyLeft')} className="toolbar-btn toolbar-btn-align-left" title="Align Left">
                    <span className="align-icon-left"></span>
                  </button>
                  <button type="button" onClick={() => formatText('justifyCenter')} className="toolbar-btn toolbar-btn-align-center" title="Align Center">
                    <span className="align-icon-center"></span>
                  </button>
                  <button type="button" onClick={() => formatText('justifyRight')} className="toolbar-btn toolbar-btn-align-right" title="Align Right">
                    <span className="align-icon-right"></span>
                  </button>
                  <button type="button" onClick={() => formatText('justifyFull')} className="toolbar-btn toolbar-btn-align-justify" title="Justify">
                    <span className="align-icon-justify"></span>
                  </button>
                  <button type="button" onClick={() => formatText('insertOrderedList')} className="toolbar-btn" title="Numbered List">
                    1.
                  </button>
                  <button type="button" onClick={() => formatText('insertUnorderedList')} className="toolbar-btn" title="Bullet List">
                    •
                  </button>
                  <button type="button" onClick={() => formatText('outdent')} className="toolbar-btn" title="Decrease Indent">
                    ←
                  </button>
                  <button type="button" onClick={() => formatText('indent')} className="toolbar-btn" title="Increase Indent">
                    →
                  </button>
                  <button type="button" onClick={() => formatText('formatBlock', 'blockquote')} className="toolbar-btn" title="Blockquote">
                    "
                  </button>
                  <button type="button" onClick={() => formatText('formatBlock', 'pre')} className="toolbar-btn" title="Code Block">
                    &lt;/&gt;
                  </button>
                  <button type="button" onClick={() => formatText('insertHorizontalRule')} className="toolbar-btn" title="Horizontal Rule">
                    ─
                  </button>
                  <button type="button" onClick={() => formatText('undo')} className="toolbar-btn" title="Undo">
                    ↶
                  </button>
                  <button type="button" onClick={() => formatText('redo')} className="toolbar-btn" title="Redo">
                    ↷
                  </button>
                  <select
                    ref={fontFamilyRef}
                    onChange={handleFontFamilyChange}
                    className="toolbar-select"
                    title="Font Family"
                  >
                    <option value="">Font</option>
                    <option value="Arial">Arial</option>
                    <option value="Helvetica">Helvetica</option>
                    <option value="Times New Roman">Times New Roman</option>
                    <option value="Courier New">Courier New</option>
                    <option value="Verdana">Verdana</option>
                    <option value="Georgia">Georgia</option>
                  </select>
                  <select
                    ref={fontSizeRef}
                    onChange={handleFontSizeChange}
                    className="toolbar-select"
                    title="Font Size"
                  >
                    <option value="">Size</option>
                    <option value="1">8pt</option>
                    <option value="2">10pt</option>
                    <option value="3">12pt</option>
                    <option value="4">14pt</option>
                    <option value="5">18pt</option>
                    <option value="6">24pt</option>
                    <option value="7">36pt</option>
                  </select>
                  <button type="button" onClick={() => formatText('removeFormat')} className="toolbar-btn" title="Clear Formatting">
                    T↗
                  </button>
                </div>
                <div
                  ref={editorRef}
                  contentEditable
                  className="wysiwyg-editor"
                  onInput={handleInput}
                  onPaste={handlePaste}
                  data-placeholder="Enter job description here..."
                />
                {charCount > MAX_CHARACTERS && (
                  <div className="char-count-error">
                    Character limit exceeded. Please reduce the content.
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="job-upload-submit-container">
            <button type="submit" className="job-upload-submit-button">
              Submit
            </button>
          </div>
        </form>
      </div>

      {/* Confirmation Overlay */}
      {showConfirmation && (
        <div className="confirmation-overlay">
          <div className="confirmation-modal">
            <h2 className="confirmation-title">Confirm Submission</h2>
            <p className="confirmation-message">
              Are you sure that all information filled out is correct before continuing with the submission?
            </p>
            <div className="confirmation-buttons">
              <button
                type="button"
                onClick={handleSubmit}
                className="confirmation-btn confirmation-btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Yes, Submit'}
              </button>
              <button
                type="button"
                onClick={() => setShowConfirmation(false)}
                className="confirmation-btn confirmation-btn-secondary"
                disabled={isSubmitting}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobUpload;
